/**************************************************************************
Name:         specialties.js
Description:  Scripts for specialty pages
Date Created: 2024-02-12 by Owen Haggerty
Modified:     
**************************************************************************/
function initSpecialtyPage(){
	/* Initializes parallax scroll effect on the header imagery */
	let imageryWrapper = document.querySelector(".specialtyHeaderImagery");
	if(imageryWrapper === null) return;
	let images = document.querySelectorAll(".specialtyHeaderImagery > *");

	window.requestAnimationFrame(()=>{
		if(matchMedia("(prefers-reduced-motion)").matches == false){
			//Autoplay the videos. If autoplay is set at page load, the videos will always be loaded,
			//even for users who won't see them
			document.querySelectorAll("video.autoplayVideo").forEach(function(elem){
				elem.setAttribute("autoplay", true);
			});
		}
	});

	
	//Add the scroll effect listener
	setSpecialtiesParallaxScroll();
	//Listen for changes to the prefers-reduced-motion preference
	matchMedia("(prefers-reduced-motion) or (max-width: 768px)").onchange = setSpecialtiesParallaxScroll;

	if(document.body.clientWidth > 768 && matchMedia("not (prefers-reduced-motion)").matches){
		//Set up the load effect on the images
		let video = document.querySelector(".specialtyHeaderImagery video.autoplayVideo");
		if(video !== null){
			//Pause the autoplaying video until the animation finishes
			video.pause();
		}
		images.forEach(function(e){
			e.style.opacity = 0;
			e.style.scale = 1.5;
			//Add opacity and scale transitions
			let currentTransition = getComputedStyle(e).transition;
			currentTransition += ", opacity 1s ease, scale 1s ease"
			e.style.transition = currentTransition;
		});
		//Show the falling into place animation
		window.requestAnimationFrame(function(){
			let bgImage = imageryWrapper.querySelector(".parallaxBackgroundImage");
			if(bgImage !== null){
				//Show the background image falling into place
				bgImage.style.opacity = 1;
				bgImage.style.scale = 1;
				if(video !== null && bgImage.contains(video)){
					window.setTimeout(()=>{
						video.play();
					}, 1000);
				}
			}
			//Show the non-background images
			window.setTimeout(function(){
				images.forEach(function(elem, index){
					//Show each element, with a short delay between them
					window.setTimeout(()=>{
						elem.style.opacity = 1;
						elem.style.scale = 1;
					}, index * 150);
				});
				if(video !== null){
					window.setTimeout(()=>{
						video.play();
					}, 1000);
				}
			}, 250);
		});
	}
	else{
		//Show the images without a transition
		images.forEach((img)=>{
			img.style.opacity = 1;
		});
	}
}

function setSpecialtiesParallaxScroll(){
	/* Sets or removes the parallax scroll effect on the headery imagery */
	let imageryWrapper = document.querySelector(".specialtyHeaderImagery");
	if(imageryWrapper === null) return;

	window.specialtyParallaxNextFrame = null;
	if(matchMedia("(prefers-reduced-motion) or (max-width: 768px)").matches == false){
		addEventListener("scroll", specialtiesOnScrollParallax);
		//Trigger a scroll to position the header images
		specialtiesOnScrollParallax();
	}
	else{
		removeEventListener("scroll", specialtiesOnScrollParallax);
		//Remove the transform from all header images
		document.querySelectorAll(".specialtyHeaderImagery > *").forEach(function(element){
			element.style.transform = "none";
		});
	}
	//Re-compute the source of any autoplaying videos
	if(!window.matchMedia("(prefers-reduced-motion)").matches){
		jQuery("video[autoplay],video.autoplayVideo").each((i, e)=>{
			e.load();
			if(!e.hasAttribute("autoplay")){
				e.setAttribute("autoplay", true);
			}
		});
	}
}

function specialtiesOnScrollParallax(){
	/* Positions the header imagery to produce the parallax effect on scroll */
	let backgroundImage = document.querySelector(".specialtyHeaderImagery > .parallaxBackgroundImage");
	let images = document.querySelectorAll(".specialtyHeaderImagery > :not(.parallaxBackgroundImage)");

	if(specialtyParallaxNextFrame !== null){
		window.cancelAnimationFrame(specialtyParallaxNextFrame);
	}

	window.requestAnimationFrame(()=>{
		//Set the positions for each image elment
		images.forEach((elem)=>{
			elem.style.transform = `translateY(-${window.scrollY / 2}px)`;
		});
		if(backgroundImage !== null){
			backgroundImage.style.transform = `translateY(-${window.scrollY / 1.5}px)`;
		}
	});
}

//Initialize the specialty page on window load or after 3 seconds, whichever comes first
if(document.readyState === "complete"){
	initSpecialtyPage();
}
else{
	let specialtiesIsLoaded = false;
	window.setTimeout(()=>{
		if(specialtiesIsLoaded) return;
		initSpecialtyPage();
		specialtiesIsLoaded = true;
	}, 3000);
	window.addEventListener("load", ()=>{
		if(specialtiesIsLoaded) return;
		initSpecialtyPage();
		specialtiesIsLoaded = true;
	});
}